export const GREETING_ROUTE = "/greetings";
export const VOUCHER_ROUTE = "/vouchers";
export const NEWS_ROUTE = "/news";
export const SESSION_ROUTE = "/sessions";
export const CONTEST_ROUTE = "/contest";
export const CONTEST_PARTICIPATION_ROUTE = "/participate";
export const REGISTRATION_ROUTE = "/register";
export const PROFILE_ROUTE = "/profile";
export const MY_WINS_ROUTE = "/wins";
export const PRIVACY_POLICY_ROUTE = "/privacy-policy";
export const IMPRINT_ROUTE = "/impressum";
export const AGB_ROUTE = "/agb";
